// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"667b36f6","239":"ace50b33","453":"0caee97c","732":"089d707c"}[chunkId] + ".chunk.js";
};